module.exports = __webpack_public_path__ + "./static/img/company_api.094d35a4b158b0ce17fd11a63572662b.png";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/fontawesome/company_api.png
// module id = ./client/src/assets/fontawesome/company_api.png
// module chunks = 0